module.exports = __webpack_public_path__ + "img/character-robot-sad.d1cce23a.svg";